<template :height="divHeight" xmlns="http://www.w3.org/1999/html">
  <div>
<!--    <div class="crumbs">-->
<!--      <el-breadcrumb separator="/">-->
<!--        <el-breadcrumb-item>巡检任务分配</el-breadcrumb-item>-->
<!--      </el-breadcrumb>-->
<!--    </div>-->
    <container class="container" >
      <div class="container2" style="width: 100%">
        <div class="container2-1">
          <div style="margin: 0 0 20px 0;padding: 0 10px 0 0">
             <span style="font-size: small;margin-right: 10px">区域选择:<el-select v-model = "areaSelect" placeholder="请选择区域" clearable>
            <el-option
              v-for="item in AreaList.result.areaList"
              :label="item.areaName"
              :value="item.areaId"
            >
            </el-option>
          </el-select></span>
            <span style="font-size: small;margin-right: 10px">开始日期:<el-date-picker type="date" placeholder="开始日期" v-model="startTimeSelect"  format="yyyy 年 MM 月 dd 日"
                                                                                   value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart2"></el-date-picker></span>
            <span style="font-size: small;margin-right: 10px">结束日期:<el-date-picker type="date" placeholder="结束日期" v-model="endTimeSelect"  format="yyyy 年 MM 月 dd 日"
                                                                                   value-format="yyyy-MM-dd" :picker-options="pickerOptionsEnd2"></el-date-picker></span>
            <span style="font-size: small;margin-right: 10px">人员选择:<el-select v-model="userSelect" placeholder="人员选择" clearable>
              <el-option
                v-for="item in UserList"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select></span>
            <el-button type="primary" @click="planSearch" size="medium">查询</el-button>
            <el-button type="info" @click="reset" size="medium">重置</el-button>
          </div>
          <span><el-button type="primary" @click="InfoAdd" size="medium">新增</el-button></span>
          <el-dialog title="新增巡检规划" :visible.sync="dialogAddCycleVisible" :close-on-click-modal='false' v-if="dialogAddCycleVisible">
            <el-form ref="form2" :model="form2" :rules="rules" label-width="80px">
              <el-form-item label="主题" prop="theme">
                <el-input :readonly="form2.readonly" v-model="form2.theme" placeholder="请填写主题" style="width:200px" id="inputTheme2" @input="changeEvent">{{form2.theme}}</el-input>
              </el-form-item>
              <el-form-item label="规划人" prop="planner">
                <el-input v-model="form2.planner" placeholder="请选择规划人" style="width: 200px" disabled>
                </el-input>
              </el-form-item>
              <el-form-item label="时间选择" required>
                <el-col :span="7">
                  <el-form-item prop="startDate" >
                    <el-date-picker type="date" placeholder="开始日期" v-model="form2.startDate" :readonly="form2.readonly" format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart1" style="width: 200px"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="1" style="margin: 0 0 0 30px">至</el-col>
                <el-col :span="7">
                  <el-form-item prop="endDate">
                    <el-date-picker type="date" placeholder="结束日期" v-model="form2.endDate" :readonly="form2.readonly" format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd" :picker-options="pickerOptionsEnd1" style="width: 200px"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item label="区域选择" prop="checkedArea">
                <el-checkbox v-model="form2.checkAll" :indeterminate="form2.isIndeterminate" @change="handleCheckAllChange">全市</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="form2.checkedArea" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="areaName in this.form2.checkedAreas" :label="areaName" :key="areaName" name="checkedArea">{{areaName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="备注" prop="textarea">
                <el-input type="textarea" v-model="form2.textarea" :readonly="form2.readonly"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('form2')" :disabled="this.submitButtonDisabled">提交</el-button>
                <el-button @click="cancel()">取消</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
        <el-table :data="PlanningInfoList.result.planningInfoList" style="width: 100%"  ref="multipleTable" >
          <!--          <el-table-column-->
          <!--            type="selection"-->
          <!--            show-overflow-tooltip-->
          <!--          >-->
          <!--          </el-table-column>-->
          <el-table-column type="expand" @click="getProgress">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="规划编号">
                  <span>{{ props.row.planTimeId }}</span>
                </el-form-item>
                <el-form-item label="规划主题">
                  <span>{{ props.row.planTitle }}</span>
                </el-form-item>
                <el-form-item label="规划人">
                  <span>{{ props.row.planners }}</span>
                </el-form-item>
                <el-form-item label="规划区域">
                  <span>{{props.row.areaList.toString()}}</span>
                </el-form-item>`
                <el-form-item label="开始时间">
                  <span>{{ props.row.startTime }}</span>
                </el-form-item>
                <el-form-item label="结束时间">
                  <span>{{props.row.endTime}}</span>
                </el-form-item>
                <el-form-item label="分配进度"><br>
                  <el-progress type="circle" :percentage="props.row.countAss"></el-progress>
                </el-form-item>
                <el-form-item  label="巡检进度"><br>
                  <el-progress type="circle" :percentage="props.row.countIns"></el-progress>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            prop="planTimeId"
            label="规划编号"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="planTitle"
            label="主题"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="_id"
            label="序号"
            v-if="this.show"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="planners"
            label="规划人"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="areaList"
            label="区域"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="规划日志">
            <template slot-scope="scope">
              <a @click="getCycleLog(scope.row._id)" style="color: #4BA2FF;cursor:pointer">查看</a>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="100" width="200px">
            <template slot-scope="scope">
              <a  @click="InfoUpdate(scope.row)" style="color: #4BA2FF;cursor:pointer">编辑</a>
              <a  @click="deleteCycle(scope.row._id)" style="margin-left:10px;color: #4BA2FF;cursor:pointer">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="规划日志" :visible.sync="dialogCheckLogVisible" :close-on-click-modal='false' v-if="dialogCheckLogVisible">
          <el-form>
            <el-form-item label="规划日志:">
              <el-table :data="this.CycleLogInfoList.result.cycleLogInfoList"
                        style="width: 100%">
                <el-table-column
                  prop="planners"
                  label="规划人员"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="planningTime"
                  label="规划时间"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="operation"
                  label="操作"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="note"
                  label="备注"
                  show-overflow-tooltip
                >
                </el-table-column>
              </el-table>
              <div class="pagination">
                <el-pagination
                  @current-change="getCycleLog(planingId)"
                  background
                  layout="prev, pager, next"
                  :page-size="10"
                  :total="logTotalCount*10"
                  :current-page.sync=" GetCycleLogInfoList.params.pageNumber">
                </el-pagination>
              </div>
            </el-form-item>
          </el-form>


        </el-dialog>
        <el-dialog title="修改巡检规划" :visible.sync="dialogUpdateCycleVisible" :close-on-click-modal='false' v-if="dialogUpdateCycleVisible">
          <el-form ref="form2" :model="form2" :rules="rules" label-width="80px">
            <el-form-item label="规划编号" prop="planTimeId">
              <el-input :disabled="true" v-model="form2.planTimeId"  style="width:200px"  >{{form2.planTimeId}}</el-input>
            </el-form-item>
            <el-form-item label="主题" prop="theme">
              <el-input :readonly="form2.readonly" v-model="form2.theme" placeholder="请填写主题" style="width:200px" id="inputTheme3" @input="changeEvent">{{form2.theme}}</el-input>
            </el-form-item>
            <el-form-item label="规划人" prop="planner">
              <el-input v-model="form2.planner" style="width: 200px" disabled></el-input>
<!--              <el-select v-model="form2.planner" placeholder="请选择规划人">-->
<!--                <el-option-->
<!--                  v-for="item in UserList"-->
<!--                  :label="item.name"-->
<!--                  :value="item.name"-->
<!--                ></el-option>-->
<!--              </el-select>-->
            </el-form-item>
            <el-form-item label="时间选择" required>
              <el-col :span="7">
                <el-form-item prop="startDate" >
                  <el-date-picker type="date" placeholder="开始日期" v-model="form2.startDate" :readonly="form2.readonly" format="yyyy 年 MM 月 dd 日"
                                  value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart1" style="width: 200px;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="1" style="margin: 0 0 0 30px">至</el-col>
              <el-col :span="7">
                <el-form-item prop="endDate">
                  <el-date-picker type="date" placeholder="结束日期" v-model="form2.endDate" :readonly="form2.readonly" format="yyyy 年 MM 月 dd 日"
                                  value-format="yyyy-MM-dd" :picker-options="pickerOptionsEnd1" style="width: 200px;"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="区域选择" prop="checkedArea">
              <el-checkbox v-model="form2.checkAll" :indeterminate="form2.isIndeterminate" @change="handleCheckAllChange">全市</el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group v-model="form2.checkedArea" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="areaName in this.form2.checkedAreas" :label="areaName" :key="areaName" name="checkedArea">{{areaName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="备注" prop="textarea">
              <el-input type="textarea" v-model="form2.textarea" :readonly="form2.readonly"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('form2')" :disabled="this.submitButtonDisabled" round>提交</el-button>
              <el-button @click="cancel()" :disabled="this.resetButtonDisabled" round>取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <div class="pagination">
          <el-pagination
            @current-change="getCycleList"
            background
            layout="prev, pager, next"
            :page-size="10"
            :total="cycleTotalCount*10"
            :current-page.sync=" GetPlanningInfo.params.pageNumber">
          </el-pagination>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
  let show = false;//用于隐藏规划表id一列
  export default {
    inject:['reload'],
    name: 'inspectionCycle',
    data(){
      return{
        planingId:'',
        divHeight:100,
        dialogAddCycleVisible : false,
        dialogUpdateCycleVisible:false,
        dialogCheckLogVisible:false,
        currentPage:1,//当前页数
        cycleTotalCount:'',//巡检表总数据条数
        logTotalCount:'',//日志表总数据条数
        submitButtonDisabled:false,
        resetButtonDisabled:false,
        areaSelect:'',
        startTimeSelect:'',
        endTimeSelect:'',
        userSelect:'',
        assignProgress:[],//分配进度
        inspectProgress:[],//巡检进度
        areaIdAndAreaName:[],
        areaNameAndAreaId:[],
        // startTime:[],//用于存放规划表中的开始时间
        // endTime:[],//用于存放规划表中的结束时间
        // cycleBefore:'',//修改操作修改之前的标题数据
        // cycleAfter:'',//修改操作修改之后的标题数据
        // plannerBefore:'',//修改操作修改之前的规划人
        // plannerAfter:'',//修改操作修改之后的规划人
        // startDateBefore:'',//修改操作修改之前的开始时间
        // startDateAfter:'',//修改操作修改之后的开始时间
        // endDateBefore:'',//修改操作修改之前的结束时间
        // endDateAfter:'',//修改操作修改之后的结束时间
        // checkedAreaBefore:[],//修改操作之前的区域
        // checkedAreaAfter:[],//修改操作之后的区域
        PlanningInfoList:{//用于存储规划表数据
          version:"1",
          result:{
            page:"#",
            planningInfoList:[
              {
                _Id:"",
                planTimeId:"",
                planTitle:"",
                planners:"",
                startTime:"",
                endTime:"",
                areaList:"",
                deleteFlag:"",
                count:"",
                countAss:"",
                countIns:""
              }
            ],
            page:"",
          },
          id:0
        },
        AreaList:{//用于存储区域表数据
          version:1,
          result:{
            areaList:[{
              areaId:"",
              areaName:"",
              managerName:"",
              childList:""
            }],
          }
        },
        GetPlanningInfo:{//获取巡检规划表信息
          "version":1.0,
          "method":"planning.GetPlanningInfo",
          "params":{
            "pageNumber":1,
            "areaId":"",
            "planners":"",
            "startTime":"",
            "endTime":""
          },
          "token":"#",
          "id":0
        },
        GetAreaInfoList:{//获取区域列表
          "version":1.0,
          "method":"area.GetAreaList",
          "params":{},
          "token":"#",
          "id":0
        },
        GetCycleLogInfoList:{//获取规划日志列表
          "version":1.0,
          "method":"planning.GetPlanningLogs",
          "params":{
            "planningId":"",
            "pageNumber":1
          },
          "token":"#",
          "id":0
        },
        GetUserInfoList:{//获取人员列表
          "version": 1,
          "method": "user.GetUserList",
          "params": {
            "username":"",
            "name":"",
            "role":""
          },
          "token": "",
          "id": 0
        },
        UserList:[
          {
            "_id":'',
            "username":'',
            "password":'',
            "name":'',
            "role":'',
            "phoneNumber":'',
            "deletedFlag":'',
            "userType":'',
            "token":'',
            "areaId":'',
            "areaName":''
          }
        ],//人员列表
        AddCycleInfo: {//新增巡检规划
          "version":1.0,
          "method":"planning.AddPlanning",
          "params": {
            "planTitle":'',
            "planners":'',
            "startTime":'',
            "endTime":'',
            "areaList":'',
            "areaNameList":'',
            "note":''
          },
          "token":"#",
          "id":0
        },
        deleteCycleInfoJudge:{//判断删除巡检规划
          "version":1,
          "method":"planning.DeletePlanningInfo",
          "params":{
            "planningId":"#"
          },
          "token":"#",
          "id":0
        },
        deleteCycleInfoConfirm:{//确认删除巡检规划
          "version":1,
          "method":"planning.ConfirmDeletePlanInfo",
          "params":{
            "planningId":"#"
          },
          "token":"#",
          "id":0
        },
        updateCycleInfoJudge:{//判断修改巡检规划
          "version":1,
          "method":"planning.SetPlanningInfo",
          "params":{
            "planningId":"",
            "planTitle":"",
            "planners":"",
            "startTime":"",
            "endTime":"",
            "areaList":"",
            "areaNameList":"",
            "note":""
          },
          "token":"#",
          "id":0
        },
        updateCycleInfoConfirm:{//确认修改巡检规划
          "version":1,
          "method":"planning.ConfirmSetPlanInfo",
          "params":{
            "planningId":"",
            "planTitle":"",
            "planners":"",
            "startTime":"",
            "endTime":"",
            "areaList":"",
            "areaNameList":"",
            "note":""
          },
          "token":"#",
          "id":0
        },

        form:{
          planningId:'',
          theme:'',
          planner:'',
          startDate:'',
          endDate:'',
          checkAll:false,
          checkedAreas:[],
          checkedArea:[],
          textarea:'',
          isIndeterminate:false,
          readonly:true
        },
        form2:{
          disabled:false,
          readonly:false,
          planningId:'',
          planTimeId:'',
          theme:'',
          planner:'',
          startDate:'',
          endDate:'',
          checkAll:false,
          checkedAreas:[],
          textarea:'',
          checkedArea:[],
          isIndeterminate:false
        },
        pickerOptionsStart:{
          disabledDate: time =>{
            let endDateVal = this.form.endDate;
            if(endDateVal){
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        },
        pickerOptionsStart1:{
          disabledDate: time =>{
            let endDateVal = this.form2.endDate;
            if(endDateVal){
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        },
        pickerOptionsStart2:{
          disabledDate: time =>{
            let endDateVal = this.startTimeSelect;
            if(endDateVal){
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        },
        pickerOptionsEnd:{
          disabledDate: time =>{
            let beginDateVal = this.form.startDate;
            if(beginDateVal){
              return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
            }
          }
        },
        pickerOptionsEnd1:{
          disabledDate: time =>{
            let beginDateVal = this.form2.startDate;
            if(beginDateVal){
              return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
            }
          }
        },
        pickerOptionsEnd2:{
          disabledDate: time =>{
            let beginDateVal = this.endTimeSelect;
            if(beginDateVal){
              return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
            }
          }
        },
        rules:{
          theme:[
            {required:true,message:'请输入主题',trigger:'blur'}
          ],
          startDate:[
            {type:'string',required:true,message:'请选择开始日期',trigger:'blur'}
          ],
          endDate:[
            {type:'string',required:true,message:'请选择结束日期',trigger:'blur'}
          ],
          checkedArea:[
            {type:'array',required:true,message:'请至少选择一个区域',trigger:'blur'}
          ],
        },
        selectionList:'',//批量删除选中的ID
        CycleLogInfoList:{//用来存储规划日志表的数据
          "version":1,
          "result":{
            cycleLogInfoList:[{
              "_id":'',
              "planningId":'',
              "planningTime":'',
              "planners":'',
              "operation":'',
              "note":''
            }],
          },
          id:""
        }

      }
    },
    methods: {
      changeEvent(){
        let changeTheme = this.form.theme;
        return changeTheme;
      },
      handleCheckAllChange(val) {//全选方法
        this.form2.checkedArea = val ? this.form2.checkedAreas : [];
        this.form2.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.form2.checkedAreas.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.form2.checkedAreas.length;
      },
      getProgress(){//获取进度

      },
      submitForm(formName) {//提交按钮

        if(this.dialogAddCycleVisible === true&&this.dialogUpdateCycleVisible === false){//新增操作
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.$confirm('是否确认提交此次巡检规划?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.addCycle();
                this.getCycleList();
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
              this.dialogAddCycleVisible = false;
            } else {
              alert('新增规划失败，请检查必填项')
            }
          })
        }
        if(this.dialogAddCycleVisible === false && this.dialogUpdateCycleVisible === true){//修改操作
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.updateCycle();
              this.dialogUpdateCycleVisible = false;
            } else {
              alert('修改规划失败，请检查必填项')
            }
          })

        }


      },
      cancel() {//重置按钮
        if(this.dialogAddCycleVisible === true&&this.dialogUpdateCycleVisible === false){
          this.dialogAddCycleVisible = false;
        }
        if(this.dialogAddCycleVisible === false && this.dialogUpdateCycleVisible === true){
          this.dialogUpdateCycleVisible = false;
        }
      },

      getCycleList() {//获取规划表数据
        let string = '';
        let startTime = [];
        let endTime = [];
        let count = [];
        let countAssArray = [];
        let countInsArray = [];
        for (let key in this.GetPlanningInfo.params) {
          if (this.GetPlanningInfo.params[key] === "") {
            this.GetPlanningInfo.params[key] = null;
          }
        };
        this.GetPlanningInfo.token = this.$store.state.token;
        this.$axios.post(this.$mainUrl, this.GetPlanningInfo).then(result => {
          if (result.data.hasOwnProperty('result')) {
            for(let i=0;i<result.data.result.planningList.length;i++){
              for(let j=0;j<result.data.result.planningList[i].areaList.length;j++){
                result.data.result.planningList[i].areaList[j] = this.areaIdAndAreaName[result.data.result.planningList[i].areaList[j].toString()].toString()
              }
             };
            for(let i=0;i<result.data.result.planningList.length;i++){
              for(let j=0;j<result.data.result.planningList[i].areaList.length;j++){
                string += result.data.result.planningList[i].areaList[j]+",";
              }
              string = string.substring(0,string.length-1);
              result.data.result.planningList[i].areaList = string;
              string = '';
            }
            this.PlanningInfoList.result.planningInfoList = result.data.result.planningList;
            for(let i=0;i<result.data.result.planningList.length;i++){
              startTime[i] = result.data.result.planningList[i].startTime;
              endTime[i] = result.data.result.planningList[i].endTime
              count[i]= parseInt(result.data.result.planningList[i].count);
              countAssArray[i] = parseInt(result.data.result.planningList[i].countAss.toString());
              countInsArray[i] = parseInt(result.data.result.planningList[i].countIns.toString());
              if(count[i] == 0){
                this.PlanningInfoList.result.planningInfoList[i].countAss = 0;
                this.PlanningInfoList.result.planningInfoList[i].countIns = 0;
              }else{
                this.PlanningInfoList.result.planningInfoList[i].countAss = countAssArray[i]/count[i]*100;
                this.PlanningInfoList.result.planningInfoList[i].countIns = countInsArray[i]/count[i]*100;
              }
            }
            this.cycleTotalCount = result.data.result.page;//获取规划表数据总数
          } else {
            this.$message({
              type: 'error',
              message: '获取巡检规划表失败' + result.data.error.message
            })
          }
        })
      },

      getAreaList() {//获取区域列表
        // for(let key in this.GetPlanningInfo.params){
        //   if(this.GetPlanningInfo.params[key] === ""){
        //     this.GetPlanningInfo.params[key] = null;
        //   }
        // };
        // this.GetAreaInfoList.token = this.$store.state.token;
        let newArray = [];
        let newArray1 = {};
        let newArray2 = {};
        this.$axios.post(this.$mainUrl, this.GetAreaInfoList).then(res => {
          console.log(res.data);
          if (res.data.hasOwnProperty('result')) {
            this.AreaList.result.areaList = res.data.result.areaList;
            for (let i = 0; i < res.data.result.areaList.length; i++) {
              //let areaArray = {};
              newArray[i] = JSON.stringify(res.data.result.areaList[i].areaName).replace("\"", "").replace("\"", "");
              newArray1[res.data.result.areaList[i].areaId] = res.data.result.areaList[i].areaName;
              newArray2[res.data.result.areaList[i].areaName] = res.data.result.areaList[i].areaId;
            }
            this.form.checkedAreas = newArray;
            this.form2.checkedAreas = newArray;
            this.areaIdAndAreaName = newArray1;
            this.areaNameAndAreaId = newArray2;
          } else {
            this.$message({
              type: 'error',
              message: '获取区域列表失败' + res.data.error.message
            })
          }
        })
      },

      getCycleLog(planingId) {//获取规划日志列表
        this.planingId = planingId;
        this.dialogCheckLogVisible = true;
        this.GetCycleLogInfoList.token = this.$store.state.token;
        this.GetCycleLogInfoList.params.planningId = planingId;
        this.$axios.post(this.$mainUrl, this.GetCycleLogInfoList).then(res => {
          if (res.data.hasOwnProperty('result')) {
            this.CycleLogInfoList.result.cycleLogInfoList = res.data.result.planningLogsList;
            this.logTotalCount = res.data.result.page;
          } else {
            this.$message({
              type: 'error',
              message: '获取规划日志列表失败' + res.data.error.message
            })
          }
        })
      },
      getUserList(){//获取人员列表
        for(let key in this.GetUserInfoList.params){
          if(this.GetUserInfoList.params[key] === ""){
            this.GetUserInfoList.params[key] = null;
          }
        }
        this.GetUserInfoList.token = this.$store.state.token;
        this.$axios.post(this.$mainUrl,this.GetUserInfoList).then(res =>{
          if(res.data.hasOwnProperty('result')){
            this.UserList = res.data.result.userList;
          }
        })
      },
      planSearch(){//查询巡检规划
        this.GetPlanningInfo.token = this.$store.state.token
        this.GetPlanningInfo.params.areaId = this.areaSelect;
        this.GetPlanningInfo.params.planners = this.userSelect;
        this.GetPlanningInfo.params.startTime = this.startTimeSelect;
        this.GetPlanningInfo.params.endTime = this.endTimeSelect;
        this.GetPlanningInfo.params.pageNumber = 1;
        for (let key in this.GetPlanningInfo.params) {
          if (this.GetPlanningInfo.params[key] === "") {
            this.GetPlanningInfo.params[key] = null;
          }
        };
        this.$axios.post(this.$mainUrl, this.GetPlanningInfo).then(result => {
          if (result.data.hasOwnProperty('result')) {
            for (let i = 0; i < result.data.result.planningList.length; i++) {
              for (let j = 0; j < result.data.result.planningList[i].areaList.length; j++) {
                result.data.result.planningList[i].areaList[j] = this.areaIdAndAreaName[result.data.result.planningList[i].areaList[j].toString()];
                // switch (result.data.result.planningList[i].areaList[j]) {
                //   case '01':
                //     result.data.result.planningList[i].areaList[j] = '主城区';
                //     break;
                //   case '02':
                //     result.data.result.planningList[i].areaList[j] = '浦口区';
                //     break;
                //   case '03':
                //     result.data.result.planningList[i].areaList[j] = '江宁区';
                //     break;
                //   case '04':
                //     result.data.result.planningList[i].areaList[j] = '六合区';
                //     break;
                //   case '05':
                //     result.data.result.planningList[i].areaList[j] = '溧水区';
                //     break;
                //   case '06':
                //     result.data.result.planningList[i].areaList[j] = '高淳区';
                //     break;
                // }
              }
              let areaString = result.data.result.planningList[i].areaList.join(",-");
              result.data.result.planningList[i].areaList = areaString.split("-");
            };
            this.PlanningInfoList.result.planningInfoList = result.data.result.planningList;
            this.cycleTotalCount = result.data.result.page;//获取规划表数据总数
          }else{
            this.$message({
              type:'info',
              message: '获取区域列表失败' + res.data.error.message
            })
          }
        })

      },
      addCycle() {//新增规划
        let newArray = [];
        this.GetCycleLogInfoList.token = this.$store.state.token;
        this.AddCycleInfo.params.planTitle = this.form2.theme;
        this.AddCycleInfo.params.planners = this.form2.planner;
        this.AddCycleInfo.params.startTime = this.form2.startDate;
        this.AddCycleInfo.params.endTime = this.form2.endDate;
        this.AddCycleInfo.params.areaNameList = this.form2.checkedArea;
        for(let i=0;i<this.form2.checkedArea.length;i++){
          newArray[i] = this.areaNameAndAreaId[this.form2.checkedArea[i].toString()];
          // switch (this.form2.checkedArea[i]) {
          //   case '主城区':
          //     newArray[i]= '01';
          //     break;
          //   case '浦口区':
          //     newArray[i]= '02';
          //     break;
          //   case '江宁区':
          //     newArray[i]= '03';
          //     break;
          //   case '六合区':
          //     newArray[i]= '04';
          //     break;
          //   case '溧水区':
          //     newArray[i]= '05';
          //     break;
          //   case '高淳区':
          //     newArray[i]= '06';
          //     break;
          // }
        }
        this.AddCycleInfo.params.areaList = newArray;
        this.AddCycleInfo.params.note = this.form2.textarea;
        this.$axios.post(this.$mainUrl, this.AddCycleInfo).then(res => {
          if(res.data.hasOwnProperty('result')){
            this.getCycleList();
            this.$message({
              type:'success',
              message:'新增成功'
            })
          }else if(res.data.hasOwnProperty('error')){
            this.$message({
              type:'info',
              message:res.data.error.message
            })
          }
        })
      },

      deleteCycle(val) {//判断删除规划
        this.deleteCycleInfoJudge.params.planningId = val;
        this.$axios.post(this.$mainUrl, this.deleteCycleInfoJudge).then(res => {
          if (res.data.result.countAssignor != 0 || res.data.result.countConfirm != 0 || res.data.result.countInspect != 0) {
            this.$confirm('该巡检规划有' + res.data.result.countAssignor + '条分配记录，有' + res.data.result.countConfirm + '条任务确认记录，' +
              '有' + res.data.result.countInspect + '条巡检记录，是否确认删除？', '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.deleteCycleInfoConfirm.params.planningId = val;
              this.$axios.post(this.$mainUrl, this.deleteCycleInfoConfirm).then(res => {
                if (res) {
                  this.form.checkedAreas = [];//清空区域多选框，防止页面刷新之后区域重复
                  this.reload();
                  this.$message({
                    type: 'success',
                    message: '删除成功'
                  })
                } else {
                  this.$message({
                    type: 'error',
                    message: '删除失败'
                  })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
          } else {
            this.$confirm('是否确认删除？', '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.deleteCycleInfoConfirm.params.planningId = val;
              this.$axios.post(this.$mainUrl, this.deleteCycleInfoConfirm).then(res => {
                if (res) {
                  this.$message({
                    type: 'success',
                    message: '删除成功'
                  })
                  this.form.checkedAreas = [];//清空区域多选框，防止页面刷新之后区域重复
                  this.reload();
                } else {
                  this.$message({
                    type: 'error',
                    message: '删除失败'
                  })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
          }

        })
      },
      // updateCycleConfirm() {
      //   let newArray = [];
      //   for (let i = 0; i < this.form.checkedArea.length; i++) {
      //     switch (this.form.checkedArea[i]) {
      //       case '主城区':
      //         newArray[i] = '01';
      //         break;
      //       case '浦口区':
      //         newArray[i] = '02';
      //         break;
      //       case '江宁区':
      //         newArray[i] = '03';
      //         break;
      //       case '六合区':
      //         newArray[i] = '04';
      //         break;
      //       case '溧水区':
      //         newArray[i] = '05';
      //         break;
      //       case '高淳区':
      //         newArray[i] = '06';
      //         break;
      //     }
      //   }
      //   this.updateCycleInfoConfirm.params.areaList = newArray;
      //   this.updateCycleInfoConfirm.params.planningId = this.form.planningId
      //   this.updateCycleInfoConfirm.params.planTitle = this.form.theme;
      //   this.updateCycleInfoConfirm.params.planners = this.form.planner;
      //   this.updateCycleInfoConfirm.params.startTime = this.form.startDate;
      //   this.updateCycleInfoConfirm.params.endTime = this.form.endDate;
      //   this.updateCycleInfoConfirm.params.areaNameList = this.form.checkedArea;
      //   this.updateCycleInfoConfirm.params.note = this.form.textarea;
      //
      //   this.$axios.post(this.$mainUrl, this.updateCycleInfoConfirm).then(res => {
      //     if (res) {
      //       this.form.checkedAreas = [];//清空区域多选框，防止页面刷新之后区域重复
      //       this.reload();
      //       this.$message({
      //         type: 'success',
      //         message: '修改成功'
      //       })
      //     } else {
      //       this.$message({
      //         type: 'error',
      //         message: '修改失败'
      //       })
      //     }
      //
      //   })
      // },
      updateCycle(){//修改规划
        for (let val in this.updateCycleInfoConfirm.params){
          if(this.updateCycleInfoConfirm.params[val] === ""){
            this.updateCycleInfoConfirm.params[val] = null;
          }
        }
        for (let val in this.updateCycleInfoJudge.params){
          if(this.updateCycleInfoJudge.params[val] === ""){
            this.updateCycleInfoJudge.params[val] = null;
          }
        }
        let newArray = [];
        this.updateCycleInfoConfirm.params.planningId = this.updateCycleInfoJudge.params.planningId = this.form2.planningId;
        this.updateCycleInfoConfirm.params.planTitle = this.updateCycleInfoJudge.params.planTitle = this.form2.theme;
        this.updateCycleInfoConfirm.params.planners = this.updateCycleInfoJudge.params.planners = this.form2.planner;
        this.updateCycleInfoConfirm.params.startTime = this.updateCycleInfoJudge.params.startTime = this.form2.startDate;
        this.updateCycleInfoConfirm.params.endTime = this.updateCycleInfoJudge.params.endTime = this.form2.endDate;
        this.updateCycleInfoConfirm.params.areaNameList = this.updateCycleInfoJudge.params.areaNameList = this.form2.checkedArea;
        for(let i=0;i<this.form2.checkedArea.length;i++){
          newArray[i] = this.areaNameAndAreaId[this.form2.checkedArea[i].toString()]
          // switch (this.form2.checkedArea[i]) {
          //   case '主城区':
          //     newArray[i]= '01';
          //     break;
          //   case '浦口区':
          //     newArray[i]= '02';
          //     break;
          //   case '江宁区':
          //     newArray[i]= '03';
          //     break;
          //   case '六合区':
          //     newArray[i]= '04';
          //     break;
          //   case '溧水区':
          //     newArray[i]= '05';
          //     break;
          //   case '高淳区':
          //     newArray[i]= '06';
          //     break;
          // }
        }
        this.updateCycleInfoConfirm.params.areaList = this.updateCycleInfoJudge.params.areaList = newArray;
        this.updateCycleInfoConfirm.params.note = this.updateCycleInfoJudge.params.note = this.form2.textarea;
        this.updateCycleInfoJudge.token = this.$store.state.token;
        this.$axios.post(this.$mainUrl,this.updateCycleInfoJudge).then(res =>{
          if(res.data.hasOwnProperty('result')){
              this.$confirm('该巡检规划已有'+res.data.result.countConfirm+'条任务确认记录和'+res.data.result.countInspect+'条已巡检记录,是否确认修改?','提示',{
                confirmButtonText:'确定',
                cancelButtonText:'取消',
                type:'warning'
              }).then(()=>{
                this.updateCycleInfoConfirm.token = this.$store.state.token;
                this.$axios.post(this.$mainUrl,this.updateCycleInfoConfirm).then(res=>{
                  if(res.data.hasOwnProperty('result')){
                    this.$message({
                      type:'success',
                      message:'修改成功'
                    })
                    this.getCycleList()
                  }else{
                    this.$message({
                      type:'error',
                      message:'修改失败'
                    })
                  }
                })
              }).catch(()=>{
                this.$message({
                  type:'info',
                  message:'已取消'
                })
              })
          }
        })
      },
      InfoUpdate(val){//编辑规划巡检规划
        this.dialogUpdateCycleVisible = true;
        this.disabled = false;
        this.form2.readonly = false;
        this.form2.theme = val.planTitle;
        this.form2.planTimeId = val.planTimeId
        this.form2.planner = val.planners;
        this.form2.startDate = val.startTime;
        this.form2.endDate = val.endTime;
        this.form2.planningId = val._id;
        this.form2.textarea = val.note;
        let newArray = [];
        newArray = val.areaList.split(",")
        // for(let i=0;i<val.areaList.length;i++){
        //   newArray[i] = val.areaList[i].replace(",","");
        // }
        this.form2.checkedArea = newArray;
        if(this.form2.checkedArea.length == 6){
          this.form2.checkAll = true;
          this.form2.isIndeterminate = false;
        }else{
          this.form2.checkAll = false;
          this.form2.isIndeterminate = false;
        }
        //this.getCycleLog(val._id);

        //this.cycleBefore = val.planTitle;
      },
      InfoCheck(row) {//点击每行数据，在左侧输入框中显示对应数据
        let newArray = [];
        let string = '';
        this.disabled = true;
        this.form.readonly = true;
        this.form.theme = row.planTitle;
        this.form.planner = row.planners;
        this.form.startDate = row.startTime;
        this.form.endDate = row.endTime;
        this.form.textarea = row.note;
        for(let i=0;i<row.areaList.length;i++){
          newArray[i] =  row.areaList[i].replace(",","");
          if(i ==row.areaList.length-1){
            string = string + newArray[i];
          }else{
            string = string+newArray[i]+",";
          }


        }
        this.form.checkedArea = string;
        if(this.form.checkedArea.length == 6){
          this.form.checkAll = true;
          this.form.isIndeterminate = false;
        }else{
          this.form.checkAll = false;
          this.form.isIndeterminate = false;
        }
        this.getCycleLog(row._id);

      },
      InfoAdd() {
        this.dialogAddCycleVisible = true;
        this.resetButtonDisabled = false;
        this.form2.isIndeterminate = false;
        this.form2.checkAll = false;
        this.form2.theme = '';
        this.form2.planner = localStorage.getItem('name');
        this.form2.startDate = '';
        this.form2.endDate = '';
        this.form2.checkedArea = [];
        this.form2.textarea = ''

      },
      reset(){
        this.areaSelect = '';
        this.startTimeSelect = '';
        this.endTimeSelect = '';
        this.userSelect = '';
      }
    },
    handleCurrentChange(currentPage){
      this.currentPage = currentPage;
    },
    mounted(){
      this.getAreaList();
      this.getUserList();
      this.getCycleList();
    }
  }

</script>

<style scoped>
  html,
  body,
  .wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .container{
    display: flex;
    justify-content: space-around;
  }
  .container2{
    margin: 20px 20px;
  }
  .container2-1{
    margin:0px 0px 20px 0px;
  }
  .container2-1 span{
    margin: 0px 0px;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

</style>
